import { Popover, Transition } from "@headlessui/react"
import { ChatAltIcon, ChevronDownIcon } from "@heroicons/react/solid"
import { Link } from "gatsby"
import React, { Fragment, useContext } from "react"
import { MessageContext } from "../customhooks.tsx/MessageContext"
import { classNames } from "../graphichs/misc"

const MenuItem = props => {
  const menuItem = props.menuItem
  const name = props.name

  return (
    <MessageContext.Consumer>
      {messageCount => (
        <Popover className="relative">
          {({ open }) => (
            <>
              <Popover.Button
                className={classNames(
                  open ? "text-meny-700" : "text-meny-700",
                  "group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-meny-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-meny-700"
                )}
              >
                {name === "Dialog" && messageCount !== undefined ? (
                  <div className="inline-flex">
                    <span>{name}</span>
                    <span></span>
                    <span className="inline-flex items-center ml-1 px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800">
                      {messageCount}
                    </span>
                  </div>
                ) : (
                  <span>{name}</span>
                )}
                <ChevronDownIcon
                  className={classNames(
                    open ? "text-meny-700" : "text-meny-700",
                    "ml-0 h-5 w-5 group-hover:text-meny-600"
                  )}
                  aria-hidden="true"
                />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute -ml-4 mt-3 transform z-10 px-2 w-screen max-w-sm sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                  <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div className="relative grid gap-6 bg-meny-700 px-5 py-6 sm:gap-8 sm:p-8">
                      {menuItem.map(item => (
                        <Link
                          key={item.id}
                          to={item.href}
                          className="inline-flex items-center justify-center rounded-md border-2 border-transparent bg-meny-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-meny-700 hover:border-2 hover:border-meny-600 focus:outline-none focus:ring-2 focus:ring-meny-700 focus:ring-offset-2 sm:w-auto"
                          activeClassName="active-link"
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      )}
    </MessageContext.Consumer>
  )
}

export default MenuItem
